import React from "react";
import UnderConstructionOverlay from "../../common/UnderConstructionOverlay";

const ComingSoon = () => {
  return (
    <UnderConstructionOverlay>
      <div className="min-h-[24rem] bg-white" />
    </UnderConstructionOverlay>
  );
};

export default ComingSoon;
